import { Component } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { restURL } from "../../../Models/restURL";
import { Subscription } from "rxjs";
import { LanguageService } from './../../../Services/languageService';
import Swal from 'sweetalert2';
import { mdlCheckPaymentStatusRes } from "../../../Models/mdlCheckPaymentStatusRes";
import { mdlCheckPaymentStatusReq } from "../../../Models/mdlCheckPaymentStatusReq";
import { mdlPayFortRequestDetailsRes } from "../../../Models/mdlPayFortRequestDetailsRes";
import { mdlProposalAddCompRenewalRes } from "../../../Models/mdlProposalAddCompRenewalRes";
import { mdlPremiumAndVehicleInfoCompRenewalRes } from "../../../Models/mdlPremiumAndVehicleInfoCompRenewalRes";
import { ProposalModel } from "../../../Models/ProposalModel";
import { motorProposalService } from "../../../Services/motorProposalService";

@Component({
    selector: 'PayfortStatusNew',
    templateUrl: './PayfortStatusNew.html',
    styleUrls: ['./PayfortStatusNew.css']
})

export class PayfortStatusNew {
    public ProposalNo: string;
    public LngSubscription: Subscription;
    public Lng: string;
    public isShowLoading: boolean;
    public PaymentDate;
    public TotalPremium: number;
    public InsuredName: string;
    public httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    public objmdlCheckPaymentStatusRes: mdlCheckPaymentStatusRes = new mdlCheckPaymentStatusRes();
    public objmdlCheckPaymentStatusReq: mdlCheckPaymentStatusReq = new mdlCheckPaymentStatusReq();
    public objAddProposalRes: mdlProposalAddCompRenewalRes = new mdlProposalAddCompRenewalRes();

    public objmdlPayFortRequestDetailsRes: mdlPayFortRequestDetailsRes = new mdlPayFortRequestDetailsRes();
    public proposalObj: ProposalModel = new ProposalModel();

    constructor(private EncriptService: motorProposalService, private http: HttpClient, private url: restURL, private lngService: LanguageService) {
        this.LngSubscription = this.lngService.grtLng().subscribe(lng => {
            this.Lng = lng
        });
        this.CheckPaymentStatus();
    }

    //<<<<<<<<<CheckPaymentStatus START>>>>>>>>>>>>>>>>>>>
    CheckPaymentStatus() {
        if (sessionStorage.getItem("objAddProposalRes") != null) {
            this.objAddProposalRes = JSON.parse(sessionStorage.getItem("objAddProposalRes"));
        }
        //this.proposalObj = JSON.parse(sessionStorage.getItem("paymentObj"));
        if (sessionStorage.getItem("paymentObj") != null) {
            this.proposalObj = JSON.parse(this.EncriptService.DecriptObject(sessionStorage.getItem("paymentObj")));
        }
        if (this.objAddProposalRes != null) {
            this.ProposalNo = this.objAddProposalRes.PROPOSALNO;
            this.TotalPremium = this.objAddProposalRes.TOTAL_PREMIUM;
            this.InsuredName = this.objAddProposalRes.INSURED_NAME;
        } else {
            this.ProposalNo = this.proposalObj.ProposalNo;
            this.TotalPremium = this.proposalObj.TotalPremium;
            this.InsuredName = this.proposalObj.Name;
        }

        if (sessionStorage.getItem("objmdlPayFortRequestDetailsRes") != null) {
        this.objmdlPayFortRequestDetailsRes = JSON.parse(sessionStorage.getItem("objmdlPayFortRequestDetailsRes"));
        }
        
        this.PaymentDate = Date.now();
        this.objmdlCheckPaymentStatusReq.ProposalNo = this.ProposalNo;
        this.objmdlCheckPaymentStatusReq.MerchentReferenceNo = this.objmdlPayFortRequestDetailsRes.merchant_reference;
        this.isShowLoading = true;
        this.http.post<mdlCheckPaymentStatusRes>(this.url.LimraOnlinePaymentsURL + "/OnlinePayments/CheckPaymentStatus", this.objmdlCheckPaymentStatusReq, this.httpOptions).toPromise().then((objCheckStatus) => {
            this.objmdlCheckPaymentStatusRes = objCheckStatus;
            this.isShowLoading = false;
            if (this.objmdlCheckPaymentStatusRes.PaymentStatus == "1") {

                Swal("<img src='assets/img/Acig.png' style='width: 25%;height: 25%;'>", "<h5 style='color:green'>Payment Done Successfully If Details Not Found Please click On Refresh Button, thank you for choosing ACIG</h5> ", "info");
            }
            else {
                Swal("<img src='assets/img/Acig.png' style='width: 25%;height: 25%;'>", "<h5 style='color:red'>Payment Not Done Thank You For Choosing Acig</h5> ", "info");
            }

        },
            (error) => {
                this.isShowLoading = false;
                Swal("<img src='assets/img/Acig.png' style='width: 25%;height: 25%;'>", "<h5 style='color:red'>Somethig Went Wrong Please Refresh Page</h5> ", "info");
            });



    }
    //<<<<<<<<<CheckPaymentStatus END>>>>>>>>>>>>>>>>>>>


}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/PayfortNew/PayfortStatusNew/PayfortStatusNew.ts